import { render } from "./nest_additional_table.vue?vue&type=template&id=5ae05588"
import script from "./nest_additional_table.vue?vue&type=script&lang=js"
export * from "./nest_additional_table.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__